module.exports = __webpack_public_path__ + "static/media/7sinif.yt.mat.1.9cf8e74e.jpg";